<template>
  <div>
    <v-layout row wrap class="mt-2">
      <v-flex xs12 sm12 style="display: flex">
        <div class="form-control" style="width: 25%;margin-top: 3px;">
          <date-picker
            style="width: 100%"
            range
            @input="onSearch"
            :shortcuts="shortcuts"
            :append-to-body="false"
            :clearable="false"
            :editable="false"
            input-class="dateSearch"
            name="DateSearch"
            v-model="selectedDate"
            valueType="date"
            format="DD/MM/YYYY"
            placeholder="Début - Fin"
          >
          </date-picker>
        </div>
        <div class="ml-2" style="width: 75%">
          <InputSearch
            class="mb-3"
            :search="search"
            @clickSearch="onSearch"
            :placeholder="'ค้นหา ชื่อโครงการ'"
          />
        </div>
      </v-flex>
    </v-layout>
    <div class="mt-3">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <Typography h2 bold label="Top โครงการ" />
        <v-btn
          variant="outlined"
          :v-tooltip="$t('export')"
          @click="modalExport = true"
          :loading="loading"
          icon
          color="#BECCDB"
          style="border-radius: 50% !important"
        >
          <img src="/static/img/exportfilter.png" alt class="responsive-img" style="height: 16px" />
        </v-btn>
        <exportxlsx ref="exbtn" :value="exData" style="display: none"></exportxlsx>
      </div>
      <v-data-table
        v-bind:pagination.sync="pagination"
        :headers="headers"
        :items="data"
        class="elevation-1"
        hide-actions
        :loading="loading"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center pa-3">
              {{ props.index + 1 }}
            </td>
            <td class="text-xs-center pa-3">
              {{ props.item.count }}
            </td>
            <td class="text-xs-center pa-3">
              {{ props.item.projectname }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <!-- </v-container> -->
    <v-dialog v-model="modalExport" persistent width="400px">
      <v-card style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <div></div>
            <div></div>

            <v-icon style="display: flex; align-items: center" @click="modalExport = false"
              >close</v-icon
            >
          </div>
          <div class="rsu">
            <v-layout column wrap justify-center align-center class="mb-3">
              <img
                src="/static/img/Export.png"
                alt
                class="responsive-img mb-1"
                style="height: 70px"
              />
              <Typography h2 bold label="ส่งออกข้อมูล" />
              <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
            </v-layout>
            <div class="text-xs-center">
              <div class="text-xs-center rsu">
                <v-btn
                  :loading="loading"
                  class="rsu"
                  round
                  small
                  outline
                  color="primary"
                  @click.stop="modalExport = false"
                  >ยกเลิก</v-btn
                >
                <v-btn
                  class="rsu"
                  :loading="loading"
                  round
                  small
                  depressed
                  style="color: #ffef01"
                  color="primary"
                  @click.stop="exportData"
                  >ยืนยัน</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Typography from '@/components/elements/Typography.vue'
import Multiselect from 'vue-multiselect'
import InputSearch from '@/components/elements/InputSearch.vue'
import DatePicker from 'vue2-datepicker'
import Exportxlsx from '@/components/elements/exportxlsx'

export default {
  components: {
    DateFilter,
    Multiselect,
    Typography,
    DatePicker,
    InputSearch,
    Exportxlsx,
  },
  data() {
    return {
      dealertype: {
        label: 'จำนวนผู้ลงทะเบียน/วัน',
        value: 'depausersregisterbydate',
      },
      optionType: [
        {
          label: 'จำนวนผู้ลงทะเบียน/วัน',
          value: 'depausersregisterbydate',
        },
        {
          label: 'จำนวนผู้ลงทะเบียน/ประเภทสมาชิก',
          value: 'depausersregisterbymembertype',
        },
      ],
      loading: false,
      search: {
        nameAll: '',
      },
      currentDate: new Date(),
      selectedDate: [new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), new Date(new Date())],
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      total: 0,
      exData: [],
      modalExport: false,
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    shortcuts() {
      const currentDate = new Date()
      const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)
      const fortyEightHoursAgo = new Date(Date.now() - 48 * 60 * 60 * 1000)
      const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
      return [
        {
          text: '24 ชั่วโมงที่แล้ว',
          onClick() {
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            const start = new Date(
              twentyFourHoursAgo.getFullYear(),
              twentyFourHoursAgo.getMonth(),
              twentyFourHoursAgo.getDate(),
              twentyFourHoursAgo.getHours(),
              twentyFourHoursAgo.getMinutes(),
              twentyFourHoursAgo.getSeconds()
            )

            const date = [start, end]
            return date
          },
        },
        {
          text: '48 ชั่วโมงที่แล้ว',
          onClick() {
            const start = new Date(
              fortyEightHoursAgo.getFullYear(),
              fortyEightHoursAgo.getMonth(),
              fortyEightHoursAgo.getDate(),
              fortyEightHoursAgo.getHours(),
              fortyEightHoursAgo.getMinutes(),
              fortyEightHoursAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )

            const date = [start, end]
            return date
          },
        },
        {
          text: 'อาทิตย์ที่แล้ว',
          onClick() {
            const start = new Date(
              oneWeekAgo.getFullYear(),
              oneWeekAgo.getMonth(),
              oneWeekAgo.getDate(),
              oneWeekAgo.getHours(),
              oneWeekAgo.getMinutes(),
              oneWeekAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: '15 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000)
            const end = new Date(currentDate)
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: 'เดือนที่แล้ว',
          onClick() {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
            const end = new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate()
            )
            // return a Date
            const date = [start, end]
            return date
          },
        },
        {
          text: '365 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
            const end = new Date()
            // return a Date
            const date = [start, end]
            return date
          },
        },
      ]
    },
    headers() {
      return [
        { text: 'อันดับ', value: 'count', align: 'center', width: '1%', sortable: false },
        { text: 'จำนวน', value: 'count', align: 'center', width: '1%', sortable: false },
        {
          text: 'ชื่อโครงการ',
          value: 'projectname',
          align: 'center',
          width: '5%',
          sortable: false,
        },
      ]
    },
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async exportData() {
      this.loading = true
      await this.getData('export')
      this.loading = false
      this.$refs.exbtn.exportxlsx()
      this.modalExport = false
    },
    setEx(data) {
      if (data) {
        let ex = []
        data.forEach((ele, index) => {
          let obj = {
            อันดับ: `${index + 1}`,
            จำนวน: ele.count,
            ชื่อโครงการ: ele.projectname,
          }
          ex.push(obj)
        })
        this.exData = ex
      }
    },
    onSearch() {
      this.loading = true
      this.getData()
      this.loading = false
    },
    getData(type) {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate[0]).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate[1]).format('YYYY-MM-DD'), // YYYY-MM-DD
          nameAll: this.search.nameAll,
        }
        this.loading = true
        api['depatopfiveusersapplyproject'](data, async (err, response) => {
          this.loading = false
          this.data = response.data
          if(type === 'export'){
             this.setEx(response.data) 
          }
          if (response.total) {
            this.total = response.total
          } else {
            this.total = 0
          }
          resolve()
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/Depatopfiveusersapplyproject.vue